const { CALCULATOR } = require('./calculator')
const { CONSTANTS } = require('./constants')

module.exports = {
  CALCULATOR,
  CONSTANTS
}
